import React from 'react';
import { Typography, Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Header from '@common/containers/Header';
import robertImg from '@assets/img/misc/404_man_robert.png';
import manchaImg from '@assets/svg/misc/bgMancha_404.svg';
import BrandImage from '@common/components/ui/BrandImage';
import styles from './NotFound.module.less';

const { Title } = Typography;

function NotFound() {

  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={styles.wrapper}>
      <div className={styles.header_wrapper}>
        <Header leftContent={<BrandImage show="icon" />} />
      </div>

      <div className={styles.content_wrapper}>
        <div className={styles.texts}>
          <img className={styles.mancha_img} src={manchaImg} alt="" />

          <Title className={styles.megatitle}>¡Oh no!</Title>
          <Title level={4}>Estas buscando algo que no existe</Title>
          <Button
            className={styles.back_btn}
            type="primary"
            size="large"
            onClick={() => history.push('/')}
          >
            {t('common.back')}
            <FontAwesomeIcon className={styles.back_btn_icon} icon={faArrowRight} />
          </Button>
        </div>
        <img className={styles.not_found_img} src={robertImg} alt="Character" />
      </div>
    </div>
  );

}

export default NotFound;
